<template>
  <div>

    <bar-chart :chart-data="osChartData" :options="defaultChartOptions"/>

    <v-card-title>PC Hardware</v-card-title>
    <v-container fluid>
      <v-row dense>
        <v-col align="center">Memory<pie-chart :chart-data="memoryChartData" :options="defaultChartOptions"/></v-col>
        <v-col align="center">CPU Cores<pie-chart :chart-data="cpuCoresChartData" :options="defaultChartOptions"/></v-col>
        <v-col align="center">CPU Types
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">Name</th>
                <th class="text-left">Count</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in statistics.cpuName" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.count }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          (and {{ this.cpuNamesOccurringOnce.true }} others with less than 6 occurrences)
        </v-col>
      </v-row>
    </v-container>

    <v-card-title>Graphic Cards</v-card-title>
    <v-container fluid>
      <v-row dense>
        <v-col align="center">Graphic Card Memory Distribution<pie-chart :chart-data="graphicsCardMemoryChartData" :options="defaultChartOptions"/></v-col>
        <v-col align="center">Graphic Card Vendors<pie-chart :chart-data="graphicsCardVendorChartData" :options="defaultChartOptions"/></v-col>
        <v-col align="center">Graphic Card Types
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">Name</th>
                <th class="text-left">Count</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in statistics.graphicsCardName" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.count }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          (and {{ this.graphicsCardNamesOccurringOnce.true }} others with less than 7 occurrences)
        </v-col>
      </v-row>
    </v-container>

    <v-card-title>Game Controllers</v-card-title>
    <v-container fluid>
      <v-row dense>
        <v-col align="center">Attached Controllers<pie-chart :chart-data="controllersAttachedChartData" :options="defaultChartOptions"/></v-col>
        <v-col align="center">Controller Types
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">Name</th>
                <th class="text-left">Count</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in statistics.controllers" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.count }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          (and {{ this.controllersOccurringOnce.true }} others with 1 occurrence)
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
import {eSailServerPublic} from "@/plugins/axios";
import _ from "lodash";
import BarChart from "@/components/charts/BarChart";
import PieChart from "@/components/charts/PieChart";
import 'chartjs-plugin-colorschemes';

export default {
  name: "UserGearStatistics",
  components: {PieChart, BarChart},
  data: () => ({
    statistics: {},
    osChartData: {},
    controllersAttachedChartData: {},
    memoryChartData: {},
    cpuCoresChartData: {},
    graphicsCardVendorChartData: {},
    graphicsCardMemoryChartData: {},
    controllersOccurringOnce: 0,
    cpuNamesOccurringOnce: 0,
    graphicsCardNamesOccurringOnce: 0,
    defaultChartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        colorschemes: {
          scheme: 'tableau.Tableau10'
        }
      }
    }
  }),
  mounted() {
    eSailServerPublic.get('admin/statistics/user-gear', { headers: { Authorization: `Bearer ` + this.$auth.token() }})
        .then(response => {

          this.statistics = response.data

          this.osChartData = {
            labels: _.map(this.statistics.os, 'name'),
            datasets: [{
              label: 'Operating Systems',
              data: _.map(this.statistics.os, 'count')
            }]
          }

          this.cpuNamesOccurringOnce = _.countBy(this.statistics.cpuName, item => { return item.count < 6 })
          this.statistics.cpuName = _.filter(this.statistics.cpuName, item => { return item.count > 5 })
          this.statistics.cpuCores = _.filter(this.statistics.cpuCores, item => { return item.count > 5 })
          this.cpuCoresChartData = {
            labels: _.map(this.statistics.cpuCores, 'name'),
            datasets: [{
              data: _.map(this.statistics.cpuCores, 'count')
            }]
          }
          this.memoryChartData = {
            labels: _.map(this.statistics.memory, item => { return item.name + " GB" }),
            datasets: [{
              data: _.map(this.statistics.memory, 'count')
            }]
          }

          this.controllersOccurringOnce = _.countBy(this.statistics.controllers, item => { return item.count === 1 })
          this.statistics.controllers = _.filter(this.statistics.controllers, item => { return item.count > 1 })
          const numControllers = this.statistics.controllers.length + this.controllersOccurringOnce.true
          this.controllersAttachedChartData = {
            labels: [ 'true', 'false' ],
            datasets: [{
              data: [ numControllers, this.statistics.os.length - numControllers ]
            }]
          }
          this.graphicsCardNamesOccurringOnce = _.countBy(this.statistics.graphicsCardName, item => { return item.count < 7 })
          this.statistics.graphicsCardName = _.filter(this.statistics.graphicsCardName, item => { return item.count > 6 })
          this.graphicsCardVendorChartData = {
            labels: _.map(this.statistics.graphicsCardVendor, 'name'),
            datasets: [{
              data: _.map(this.statistics.graphicsCardVendor, 'count')
            }]
          }
          this.graphicsCardMemoryChartData = {
            labels: _.map(this.statistics.graphicsCardMemory, item => { return (item.name === "0" ? "1" : item.name) + " GB" }),
            datasets: [{
              data: _.map(this.statistics.graphicsCardMemory, 'count')
            }]
          }
        })
  }
}
</script>

<style scoped>

</style>